import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '分类浏览', href: '/category' },
    { label: '排行榜', href: '/category?sort=rating' },
    { label: '最新更新', href: '/category?sort=newest' },
  ],
  categories: [
    { label: '恋爱漫画', href: '/category/romance' },
    { label: '奇幻漫画', href: '/category/fantasy' },
    { label: '动作漫画', href: '/category/action' },
    { label: '悬疑漫画', href: '/category/mystery' },
    { label: '穿越漫画', href: '/category/isekai' },
    { label: '校园漫画', href: '/category/school' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌故事', href: '/about#brand' },
    { label: '用户口碑', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 text-white mb-4" aria-label="动漫之家">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl"></i>
              </span>
              <span className="text-xl font-heading font-bold whitespace-nowrap">动漫之家</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读平台。热门新作实时更新，画质高清、加载流畅。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm">热门分类</h4>
            <ul className="space-y-2">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm">关于我们</h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 动漫之家 DongManZhiJia.com 版权所有
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors">用户协议</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-300 transition-colors">隐私政策</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-300 transition-colors">免责声明</a>
          </p>
        </div>
      </div>
    </footer>
  );
}